import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type FeedbackSoundCategory =
  | 'success'
  | 'save'
  | 'error'
  | 'warning'
  | 'info'
  | 'notification'
  | 'fuelStation'

interface FeedbackSettingsState {
  enabled: boolean
  volume: number
  categories: Record<FeedbackSoundCategory, boolean>
  setEnabled: (enabled: boolean) => void
  setVolume: (volume: number) => void
  setCategoryEnabled: (category: FeedbackSoundCategory, enabled: boolean) => void
}

const defaultCategories: Record<FeedbackSoundCategory, boolean> = {
  success: true,
  save: true,
  error: true,
  warning: true,
  info: true,
  notification: true,
  fuelStation: true,
}

export const useFeedbackSettingsStore = create<FeedbackSettingsState>()(
  persist(
    (set) => ({
      enabled: true,
      volume: 0.75,
      categories: defaultCategories,
      setEnabled: (enabled) => set({ enabled }),
      setVolume: (volume) => set({ volume: Math.min(1, Math.max(0.1, volume)) }),
      setCategoryEnabled: (category, enabled) =>
        set((state) => ({
          categories: { ...state.categories, [category]: enabled },
        })),
    }),
    {
      name: 'feedback-sound-settings',
    }
  )
)
